import React from "react";

function AboutPage() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-12 font-sans text-slate-800">
      <div className="mb-12">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8 text-center">&Uuml;ber mich</h1>
        <div className="mt-6 text-lg leading-relaxed text-slate-700 bg-slate-50 p-6 rounded-xl border border-slate-100 shadow-sm">
          <p>
            <b>
              Willkommen auf meiner Seite! Als angehender Wirtschaftsinformatiker
              m&ouml;chte ich Ihnen hier meine Leidenschaft f&uuml;r die Softwareentwicklung
              und Data Science n&auml;herbringen. Mein Ziel ist es, innovative Anwendungen
              zu entwickeln und durch die Analyse komplexer Daten wertvolle
              Erkenntnisse zu gewinnen. Die Kombination aus technischer Umsetzung
              und analytischem Denken treibt mich dabei an.
            </b>
          </p>
        </div>

        <div className="mt-12 space-y-8">
          <h2 className="text-2xl font-bold text-slate-900 border-b pb-2">Meine Vision in der Informatik</h2>

          <div>
            <h3 className="text-xl font-semibold text-slate-800 mb-3">Der Weg in die IT</h3>
            <p className="text-slate-600 leading-relaxed">
              Meine Reise in die Welt der Technologie begann mit der Entdeckung der
              Programmierung und entwickelte sich schnell zu einer Faszination f&uuml;r
              die vielf&auml;ltigen M&ouml;glichkeiten der IT. Was als allgemeines Interesse
              an Computern begann, hat sich zu einer gezielten Spezialisierung
              sowohl im Bereich der Applikationsentwicklung als auch in Data Science
              entwickelt. Die F&auml;higkeit, Probleme durch Code zu l&ouml;sen und Daten
              nutzbar zu machen, begeistert mich jeden Tag aufs Neue.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-slate-800 mb-3">Meine Spezialisierung</h3>
            <p className="text-slate-600 leading-relaxed">
              Meine Begeisterung f&uuml;r die Informatik wird durch ein breites Spektrum
              an Interessen getragen. Durch den <b>CS50X</b> <em>(Harvard University)</em> Kurs
              habe ich ein tiefes Verst&auml;ndnis f&uuml;r die Grundlagen der Informatik erlangt.
              Gleichzeitig vertiefte das <b>IBM Data Science Professional Certificate</b> mein
              Wissen in Machine Learning und Datenanalyse. Ich sehe mich als Entwickler,
              der sowohl backend-seitige Logik und Datenbanken beherrscht, als auch
              moderne KI-Modelle integrieren und nutzen kann.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-slate-800 mb-3">Technische Infrastruktur und Tools</h3>
            <p className="text-slate-600 leading-relaxed">
              Um meine Projekte optimal umzusetzen, nutze ich eine vielseitige
              Infrastruktur. Dazu geh&ouml;rt mein eigener Server, auf dem ich Dienste
              hoste und Experimente durchf&uuml;hre. Er bietet mir unter anderem eine{" "}
              <b>JupyterHub-Umgebung</b> f&uuml;r Datenanalysen. Kenntnisse in{" "}
              <em>Server-Administration</em>, Deployment und DevOps sehe ich als
              essentiell an, um robuste und skalierbare Anwendungen zu entwickeln,
              die &uuml;ber den reinen Code hinausgehen.
            </p>
          </div>
        </div>

        <div className="mt-12 space-y-8">
          <h2 className="text-2xl font-bold text-slate-900 border-b pb-2">Expertise und Weiterbildung</h2>

          <div>
            <h3 className="text-xl font-semibold text-slate-800 mb-3">Fundierte Ausbildung in Data Science</h3>
            <p className="text-slate-600 leading-relaxed">
              Meine Expertise basiert auf einer Kombination aus strukturierter
              Ausbildung und praktischer Erfahrung. An der EDV-Schule Plattling
              erhalte ich eine solide Grundlage in Wirtschaftsinformatik, die ich
              gezielt durch spezialisierte Kurse wie <b>CS50X</b> und den{" "}
              <b>IBM Data Science Professional Certificate</b> in Richtung Data
              Science ausbaue. Diese Kombination erm&ouml;glicht mir, sowohl die
              technischen Aspekte der Datenanalyse als auch deren
              wirtschaftliche Anwendungen zu verstehen.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-slate-800 mb-3">Aktuelle Projekte</h3>
            <p className="text-slate-600 leading-relaxed">
              Aktuell fokussiere ich mich auf meine Abschlussprojekte an der EDV-Schule:
              Ein <b>ABAP-Projekt</b> (Plattform f&uuml;r Wohnungssuche) und ein{" "}
              <b>Java-Projekt</b> (Online-Casino), welche mir fundierte Kenntnisse in
              Softwarearchitektur und Datenbanken vermitteln.
              Besonders am Herzen liegt mir mein privates Projekt: Ein <b>KI-Sprachenlern-Roleplay</b>.
              Hier verbinde ich moderne Webtechnologien mit Large Language Models, um
              ein interaktives Lernerlebnis zu schaffen. Dieses Projekt demonstriert
              meine F&auml;higkeit, komplexe KI-Systeme in nutzerfreundliche Anwendungen
              zu integrieren.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutPage;
